import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as PasswordValidator from 'password-validator';

export class ComplexPasswordValidator {
    private static passwordSchema = new PasswordValidator()
        .is().min(8) // Minimum length 8
        .is().max(30) // Maximum length 30
        .has().uppercase(1) // At least 1 uppercase letter
        .has().lowercase(1) // At least 1 lowercase letter
        .has().digits(1)    // At least 1 digit
        .has().symbols(1)   // At least 1 special character
        .has().not().spaces(); // No spaces

    static passwordValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        if (!value) return null; // Skip validation if no value (handled by 'required')
        const errors = ComplexPasswordValidator.passwordSchema.validate(value, { list: true }) as any[];
        return errors.length ? { passwordStrength: errors.map(error => error.message) } : null;
    }
}
